var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeInsurancePurchase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "url(#lifeInsurancePurchaseSvg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 38c.21 0 .46-.07.75-.2.3-.13.58-.28.84-.44a48.77 48.77 0 0 0 7.61-5.62 25.32 25.32 0 0 0 5.02-6.06 12.6 12.6 0 0 0 1.78-6.3c0-1.39-.24-2.65-.71-3.8a8.8 8.8 0 0 0-4.86-4.9 9.28 9.28 0 0 0-3.55-.68c-1.57 0-2.94.38-4.1 1.13A8.4 8.4 0 0 0 24 14.08a8.53 8.53 0 0 0-2.8-2.95A7.33 7.33 0 0 0 17.1 10a8.85 8.85 0 0 0-8.4 5.59 9.97 9.97 0 0 0-.7 3.8c0 2.1.6 4.2 1.78 6.29a25.5 25.5 0 0 0 5 6.06 49.48 49.48 0 0 0 7.63 5.62c.25.16.52.31.8.44.3.13.57.2.79.2Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lifeInsurancePurchaseSvg",
    x1: 0,
    y1: 0.26,
    x2: 49.22,
    y2: 46.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBB63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB5D00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeInsurancePurchase);
export default __webpack_public_path__ + "static/media/LifeInsurancePurchase.a49a0c7fdcd81e5031b3d50da8f09ee5.svg";
export { ForwardRef as ReactComponent };